import styles from "./styles.module.scss"

import type { FC, HTMLAttributes } from "react"

interface ContainerProps
  extends HTMLAttributes<HTMLUListElement> { }


export const Container: FC<ContainerProps> = props => (
  <ul className={styles.container} {...props} />
)
